import { render, staticRenderFns } from "./ProductPictures.vue?vue&type=template&id=9d04c792"
import script from "./ProductPictures.vue?vue&type=script&lang=js"
export * from "./ProductPictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports